export let visite =[
    {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"planifiée"          
    },
    {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"en cours"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"effectuée"
        
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"reportée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"planifiée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"effectuée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"creée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"reportée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"reportée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"reportée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"effectuée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"effectuée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"effectuée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"effectuée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"effectuée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"effectuée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"effectuée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"effectuée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"effectuée"
          
    }, {
        "Acheteurclient":"company RS",
        "Secteur":"Secteur X",
        "Datevisite":"01/02/2020",
        "Adressepostale":"Pole industriel X, boulvard Y",
        "Ville":"Casablanca",
        "status":"effectuée"
          
    }
    
]